/**
 * VAGUE 30B — Records personnels strip.
 *
 * Displays the telepro's all-time bests (calls in a day, sales in a day,
 * sales in a week) as a friendly motivational strip below the KPI cards.
 *
 * Props:
 *   records — { best_calls_day, best_sales_day, best_sales_week, total_calls_all_time }
 */
import React from "react";
import { Trophy, Phone, Star, Calendar } from "@phosphor-icons/react";

function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
  } catch (_e) { return iso; }
}

function RecordChip({ icon, label, value, date, testid }) {
  return (
    <div
      className="flex items-center gap-3 px-4 py-3 bg-primary/5 border border-primary/20 rounded-sm min-w-0 flex-1"
      data-testid={testid}
    >
      <div className="shrink-0 text-primary">{icon}</div>
      <div className="min-w-0">
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground font-semibold truncate">
          {label}
        </div>
        <div className="font-bold text-sm">
          {value > 0 ? (
            <>
              {value}
              {date && <span className="text-muted-foreground font-normal text-xs ml-2">({fmtDate(date)})</span>}
            </>
          ) : (
            <span className="text-muted-foreground italic">Aucun encore</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default function RecordsStrip({ records }) {
  if (!records) return null;
  const bcd = records.best_calls_day || { value: 0, date: null };
  const bsd = records.best_sales_day || { value: 0, date: null };
  const bsw = records.best_sales_week || { value: 0, week_start: null };

  return (
    <div className="mb-6" data-testid="records-strip">
      <div className="flex items-center gap-2 mb-2">
        <Trophy size={16} weight="duotone" className="text-primary" />
        <h2 className="font-display text-sm font-bold uppercase tracking-wider">
          Tes records
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <RecordChip
          icon={<Phone size={20} weight="duotone" />}
          label="Meilleur jour · appels"
          value={bcd.value}
          date={bcd.date}
          testid="record-best-calls-day"
        />
        <RecordChip
          icon={<Star size={20} weight="duotone" />}
          label="Meilleur jour · ventes"
          value={bsd.value}
          date={bsd.date}
          testid="record-best-sales-day"
        />
        <RecordChip
          icon={<Calendar size={20} weight="duotone" />}
          label="Meilleure semaine · ventes"
          value={bsw.value}
          date={bsw.week_start}
          testid="record-best-sales-week"
        />
      </div>
    </div>
  );
}
